<template>
  <div class="fBanner">
      <div class="title">内容流转全链路数字化</div>
      <div class="cardNum">
        <div class="item">
          <div class="rowOne">合规</div>
          <div class="rowTwo">67<span>%</span></div>
          <div class="rowThree">素材违规内容降低</div>
        </div>
        <div class="item">
          <div class="rowOne">增效</div>
          <div class="rowTwo">10<span>x</span></div>
          <div class="rowThree">内容生产效率提升</div>
        </div>
        <div class="item">
          <div class="rowOne">降本</div>
          <div class="rowTwo">5<span>x</span></div>
          <div class="rowThree">内容生产成本降低</div>
        </div>
        <div class="item">
          <div class="rowOne">便捷性</div>
          <div class="rowTwo">50<span>x</span></div>
          <div class="rowThree">内容分发效率提升</div>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        
      };
    },
   
  }
</script>
<style lang="scss" scoped>
  .fBanner{
        background-image: url('https://respool.isheji.com/isheji/static/qiye/image/product/f_banner.png');
        width: 100%;
        min-width: 1400px;
        height: 437px;
        background-size: cover;
        background-position-x: center;
        position: relative;
        background-size: cover;
        padding-top: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
        margin-bottom: 56px;
      }
      .cardNum{
        display: flex;
        justify-content: center;
        margin-bottom: 80px;
        .item{
          margin-right: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .rowOne{
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 28px;
            margin-bottom: 8px;
          }
          .rowTwo{
            font-size: 80px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 112px;
            span{
              margin-left: 8px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 33px;
            }
          }
          .rowThree{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 28px;
            margin-top: 8px;
          }
          &:last-child{
            margin-right: 0px;
          }
        }
       
      }
    }
</style>